import React, { Component } from "react";
import RegisterUserForm from "./RegisterUserForm.jsx";
import LoginForm from "./LoginForm.jsx";
class LoginRegister extends Component {
  state = {};
  render() {
    const props = this.props;
    return (
      <div className="container">
        <div className="page-header">
          <h3>Suggest Product Feature or Improvement</h3>
        </div>

        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <LoginForm {...props}></LoginForm>
          </div>

          <div className="col-xl-6 col-lg-6 col-md-6">
            <RegisterUserForm {...props}></RegisterUserForm>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginRegister;
